import React, { Component } from 'react';
import styles from './PrimaryButtonComponent.module.scss';

import { injectIntl } from 'react-intl';
import messages from './PrimaryButtonComponent.intl';

@injectIntl
export default class PrimaryButtonComponent extends Component {
  static defaultProps = {
    isBusy: false
  };

  render() {
    const { className } = this.props;
    const { text, subText, link, onClick, isBusy, openNewTab } = this.props;

    return link ? (
      <a
        rel={openNewTab ? 'noreferrer' : ''}
        target={openNewTab ? '_blank' : ''}
        href={link}
        className={`${styles.PrimaryButtonComponent} ${className}`}
      >
        {subText && <p className={styles.GreyText}>{subText}</p>}
        <p>{text}</p>
      </a>
    ) : isBusy ? (
      <span className={`${styles.PrimaryButtonComponent} ${className}`}>
        <p>{this.props.intl.formatMessage(messages.button)}</p>
      </span>
    ) : (
      <span
        onClick={onClick}
        className={`${styles.PrimaryButtonComponent} ${className}`}
      >
        {subText && <p className={styles.GreyText}>{subText}</p>}
        <p>{text}</p>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/PrimaryButtonComponent/PrimaryButtonComponent.js